<template>
  <div class="container">
    <div class="website-header-bg">
      <div class="website-header">
        <dir class="website-header-container flex-between">
          <div class="container-left">
            <img src="@/assets/imgs/log.png" alt="" />
          </div>
          <div class="container-right flex-between">
            <div
              class="popup flex-start"
              @mouseenter="showPopup = true"
              @mouseleave="handleTriggerLeave"
            >
              手机直通车
              <img
                src="@/assets/imgs/down.svg"
                class="down-icon"
                :class="{ 'rotate-180': showPopup }"
                alt=""
              />
              <phonePopup v-if="showPopup" ref="popupRef" />
            </div>
            <div class="orderBtn" @click="orderNow">立即下单</div>
          </div>
        </dir>
      </div>

      <div class="website-header-middle">
        <img class="logbig" src="@/assets/imgs/logbig.png" alt="" />
        <div class="slogin">五金、家居、建材产业互联网服务领军者</div>
        <div class="slogin-des">
          整合全品类资源，以数字化驱动，为行业提供高效供应链解决方案
        </div>

        <div class="orderBtn" @click="orderNow">
          <img src="@/assets/imgs/orderbtn.png" alt="" />
        </div>
      </div>
    </div>

    <!-- 品牌定位 -->
    <div class="brandSwiper">
      <brandSwiper />
    </div>

    <!-- 服务商五维价值赋能 -->
    <div class="serviceTabs">
      <serviceTabs />
    </div>

    <!-- 下载app -->
    <div class="download flex-between">
      <div class="download-left">
        <p>立即体验</p>
        <p>手机纵购直通车</p>
        <span>同时支持 HarmonyOS，Android，iOS版本</span>
      </div>
      <div class="download-right flex-start">
        <div class="right-inner flex-center">
          <img src="@/assets/imgs/app.png" alt="" />
          <span>扫码下载客户端</span>
        </div>
        <div class="right-inner flex-center">
          <img src="@/assets/imgs/wxgzh.jpg" alt="" />
          <span>官方公众号</span>
        </div>
        <div class="right-inner flex-center">
          <img src="@/assets/imgs/wx.jpg" alt="" />
          <span>扫码进入小程序</span>
        </div>
      </div>
    </div>

    <!-- 可靠数据累计 -->
    <div class="dataAccumulation">
      <div class="dataAccumulation-item">
        <div class="item-header">
          <p>可靠数据积累</p>
          <span
            >多年行业积累，致力于构建五金、家居、建材全品类产业互联网服务平台</span
          >
        </div>

        <div class="item-middle flex-start">
          <div
            class="flex-item"
            v-for="(item, index) in dataItems"
            :key="index"
          >
            <img :src="item.img" alt="" />
            <div class="big-text flex-start">
              <p>{{ item.num }}</p>
              <span>{{ item.unit }}</span>
            </div>
            <div class="small-text">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 口号 -->
    <div class="slogan">
      <div class="slogan-item">
        <p>找建材，上纵购直通车</p>
        <div class="item-des flex-start">
          <span>150万+</span> 海量五金家居建材商品，满足您的一切采购需求！
        </div>
      </div>
    </div>

    <!--终端门店价值体系  -->
    <div class="store-value">
      <stroeValue />
    </div>

    <!-- 售后省心无忧，服务响应及时 -->
    <div class="after-sales">
      <div class="after-sales-item">
        <div class="title">售后省心无忧，服务响应及时</div>
        <div class="item-middle">
          <h2>平台专业服务支持</h2>
          <div class="flex-start flex-box">
            <div
              class="des-item flex-start"
              v-for="(item, index) in aftersalesList"
              :key="index"
            >
              <img :src="item.img" alt="" />
              <div class="des-item-right">
                <p>{{ item.title }}</p>
                <span>{{ item.desc }}</span>
              </div>
            </div>
          </div>
        </div>
        <img class="kf" src="https://ztc-obs.zgztc.cn/2025/12/25/0565bc8f-0ee0-4c0a-9323-7032b6d50a75.png" alt="" />
      </div>
    </div>

    <!-- 轻松购物 -->
    <div class="enjoy-shopping">
      <div class="enjoy-shopping-item">
        <div class="title">购物更轻松，支付更快捷</div>
        <div class="des">
          <span>150万+</span> 海量五金家居建材商品，满足您的一切采购需求！
        </div>
        <div class="item-button flex-start" @click="orderNow">
          立即下单
          <img src="@/assets/imgs/right.png" alt="" class="arrow-icon" />
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="foot">
      <div class="foot-item flex-between">
        <div class="foot-item-left">
          <img src="@/assets/imgs/logwhite.png" alt="" />
          <div class="des flex-start">
            <p>Copyright © 2025 深圳市纵购电子商务有限公司</p>
            <p style="margin-left: 20px">备案号:</p>
            <p style="cursor: pointer" class="beian-link" @click="jumpMiit">
              粤ICP备14093582号-22
            </p>

          <div class="police flex-start">
            <img src="@/assets/imgs/police.png" alt="" />
            <a style="cursor: pointer" class="beian-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=44060602003087" rel="noreferrer" target="_blank">粤公网安备44060602003087号</a>
          </div>
          </div>
        </div>
        <div class="foot-item-right">
          <p>联系我们</p>
          <span>400-168-2128</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import phonePopup from "./components/phonePopup.vue";
import brandSwiper from "./components/brandSwiper.vue";
import serviceTabs from "./components/serviceTabs.vue";
import stroeValue from "./components/stroeValue.vue";
export default {
  name: "HomePage",
  components: {
    phonePopup,
    brandSwiper,
    serviceTabs,
    stroeValue,
  },
  data() {
    return {
      showPopup: false, // 控制弹窗显示/隐藏
      timer: null, // 延迟隐藏的定时器

      dataItems: [
        {
          img: require("@/assets/imgs/dataimgone.png"),
          num: "11",
          unit: "大",
          desc: "产品品类",
        },
        {
          img: require("@/assets/imgs/dataimgtwo.png"),
          num: "150",
          unit: "万+",
          desc: "产品SKU",
        },
        {
          img: require("@/assets/imgs/dataimgthree.png"),
          num: "24",
          unit: "小时",
          desc: "全平台支持",
        },
      ],

      aftersalesList: [
        {
          img: require("@/assets/imgs/aftersalesone.png"),
          title: "贴心服务",
          desc: "统一流程规范服务",
        },
        {
          img: require("@/assets/imgs/aftersalestwo.png"),
          title: "专业团队",
          desc: "精准答疑解惑",
        },
        {
          img: require("@/assets/imgs/aftersalesthree.png"),
          title: "极速响应",
          desc: "迅速行动及时处理",
        },
        {
          img: require("@/assets/imgs/aftersalesfour.png"),
          title: "售后无忧",
          desc: "强力支撑护航运营",
        },
      ],
    };
  },
  mounted() {
    // 给弹窗绑定鼠标进入/离开事件（组件挂载后绑定）
  const popupEl = this.$refs.popupRef && this.$refs.popupRef.$el;
    if (popupEl) {
      popupEl.addEventListener("mouseenter", this.handlePopupEnter);
      popupEl.addEventListener("mouseleave", this.handlePopupLeave);
    }
  },
  beforeDestroy() {
    // 清除定时器和事件监听，避免内存泄漏
    clearTimeout(this.timer);
    const popupEl = this.$refs.popupRef && this.$refs.popupRef.$el;
    if (popupEl) {
      popupEl.removeEventListener("mouseenter", this.handlePopupEnter);
      popupEl.removeEventListener("mouseleave", this.handlePopupLeave);
    }
  },
  methods: {
    // 离开触发区：延迟隐藏弹窗（避免快速移到弹窗时关闭）
    handleTriggerLeave() {
      this.timer = setTimeout(() => {
        this.showPopup = false;
      }, 200);
    },
    // 进入弹窗：清除延迟，保持显示
    handlePopupEnter() {
      clearTimeout(this.timer);
      this.showPopup = true;
    },
    // 离开弹窗：直接隐藏
    handlePopupLeave() {
      this.showPopup = false;
    },

    // 跳到工信网站
    jumpMiit() {
      window.open("https://beian.miit.gov.cn", "_blank");
    },

    // 立即下单
    orderNow(){
      window.open("https://vmall.zgztc.cn", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  box-sizing: border-box;
  overflow-x: hidden;

  .website-header-bg {
    background-image: url("https://ztc-obs.zgztc.cn/2025/12/25/fdd359e0-cadd-48fb-97f9-6f3d55f00c25.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 870px;
    padding-top: 72px;
    box-sizing: border-box;

    .website-header {
      width: 100%;
      max-width: 1920px;
      height: 72px;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(20px);
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;

      .website-header-container {
        width: 100%;
        max-width: 1170px;
        margin: auto;
        height: 72px;
        padding: 0 20px;
        box-sizing: border-box;

        .container-left {
          width: 160px;
          height: 45px;
          margin: auto 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .container-right {
          width: 250px;
          font-size: 16px;
          font-family: MicrosoftYaHei;
          .popup {
            position: relative;
            margin: auto 0;
            color: #3e3e3e;
            cursor: pointer;
            .down-icon {
              width: 15px;
              height: 15px;
              margin: 5px;
              transition: transform 0.3s ease;
            }

            .rotate-180 {
              transform: rotate(180deg);
            }
          }
          .orderBtn {
            cursor: pointer;
            width: 104px;
            height: 36px;
            background: linear-gradient(270deg, #ff5a32 0%, #ff3a55 100%);
            border-radius: 23px;
            text-align: center;
            line-height: 36px;
            color: #ffffff;
            margin: auto 0;

            &:hover {
              background: linear-gradient(
                  rgba(255, 255, 255, 0.2),
                  rgba(255, 255, 255, 0.2)
                ),
                // 20% 白色渐变层
                linear-gradient(270deg, #ff5a32 0%, #ff3a55 100%);
            }
          }
        }
      }
    }

    .website-header-middle {
      width: 100%;
      max-width: 1170px;
      margin: auto;
      margin-top: 250px;
      text-align: center;
      padding: 0 20px;
      box-sizing: border-box;
      .logbig {
        width: 280px;
        height: 51px;
        margin: auto;
      }
      .slogin {
        font-family: MicrosoftYaHei;
        font-size: 40px;
        color: #585f65;
        margin: 30px auto 20px auto;
      }

      .slogin-des {
        font-family: MicrosoftYaHei;
        font-size: 20px;
        color: #8d8d8d;
      }

      .orderBtn {
        width: 174px;
        height: 54px;
        margin: 48px auto;
        cursor: pointer;
        position: relative; // 给伪元素定位用
        transition: all 0.3s ease; // 过渡动画，效果更丝滑
        img {
          width: 100%;
          height: 100%;
          object-fit: cover; // 保持图片比例
        }
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0);
          border-radius: inherit;
          pointer-events: none;
          transition: background 0.3s ease;
        }

        &:hover::after {
          background: rgba(255, 255, 255, 0.2); // 20% 白色层
        }
      }
    }
  }

  .brandSwiper {
    height: 610px;
    background: white;
    width: 100%;
  }

  .serviceTabs {
    background: linear-gradient(
      180deg,
      rgba(255, 243, 245, 0) 0%,
      #fef1f4 15%,
      #fff9f9 34%,
      #ffffff 100%
    );
    display: block;
    border: 1px solid transparent;
    width: 100%;
  }

  .download {
    background-image: url("https://ztc-obs.zgztc.cn/2025/12/25/924c113f-024a-49d0-8e65-39cb882a2d25.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    max-width: 1170px;
    height: 375px;
    margin: 100px auto 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    .download-left {
      margin-top: 108px;
      p {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 36px;
        color: #3e3e3e;
        line-height: 54px;
      }
      span {
        display: block;
        font-family: MicrosoftYaHei;
        font-size: 20px;
        color: #3e3e3e;
        line-height: 20px;
        margin-top: 45px;
      }
    }
    .download-right {
      flex: 1;
      justify-content: flex-end;
      flex-wrap: wrap;
      .right-inner {
        font-family: MicrosoftYaHei;
        font-size: 20px;
        color: #3e3e3e;
        text-align: center;
        width: 150px;
        margin-left: 20px;
        img {
          width: 150px;
          height: 150px;
          padding: 4px;
          background: #ffffff;
          box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          margin-bottom: 15px;
        }
      }
    }
  }

  .dataAccumulation {
    background-image: url("https://ztc-obs.zgztc.cn/2025/12/25/3ea02a09-463d-419e-8b0e-3cfb07f0ddd7.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    max-width: 1920px;
    height: 480px;
    margin: 100px auto 0 auto;
    display: flex;
    flex-direction: column;
    .dataAccumulation-item {
      width: 100%;
      max-width: 1170px;
      margin: auto;
      padding: 0 20px;
      box-sizing: border-box;
      .item-header {
        p {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 48px;
          color: #ffffff;
          line-height: 48px;
        }
        span {
          margin-top: 25px;
          display: block;
          height: 24px;
          font-family: MicrosoftYaHei;
          font-size: 20px;
          color: #ffffff;
          line-height: 24px;
        }
      }

      .item-middle {
        margin-top: 80px;
        display: flex;
        flex-wrap: wrap;
        gap: 60px;
        .flex-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          margin-right: 0;

          img {
            width: 30px;
            height: 30px;
          }

          .big-text {
            color: #ffffff;
            font-weight: bold;
            align-items: flex-end;
            margin: 20px 0 10px 0;
            p {
              font-size: 42px;
              line-height: 1;
              margin: 0;
            }
            span {
              display: block;
              font-size: 20px;
              line-height: 1;
              margin-bottom: 5px;
              margin-left: 5px;
            }
          }
          .small-text {
            height: 21px;
            font-family: MicrosoftYaHei;
            font-size: 16px;
            color: #ffffff;
            line-height: 21px;
          }
        }
      }
    }
  }

  .slogan {
    background-image: url("https://ztc-obs.zgztc.cn/2025/12/25/7127e89a-aec2-4855-8017-6184a586e9a3.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    max-width: 1920px;
    height: 280px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .slogan-item {
      width: 100%;
      max-width: 1170px;
      margin: auto;
      padding: 0 20px;
      box-sizing: border-box;
      p {
        height: 64px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 48px;
        color: #3e3e3e;
        line-height: 64px;
      }
      .item-des {
        margin-top: 15px;
        display: block;
        height: 29px;
        font-family: Helvetica, Helvetica;
        font-size: 24px;
        color: #3e3e3e;
        span {
          font-weight: bold;
        }
      }
    }
  }

  .store-value {
    width: 100%;
    max-width: 1920px;
    height: 778px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: white;
  }

  .after-sales {
    background-image: url("https://ztc-obs.zgztc.cn/2025/12/25/b446cc06-0177-4cae-a377-ffa134b44d01.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    max-width: 1920px;
    height: 710px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .after-sales-item {
      width: 100%;
      max-width: 1170px;
      margin: 90px auto;
      position: relative;
      padding: 0 20px;
      box-sizing: border-box;
      .title {
        height: 48px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 48px;
        color: #3e3e3e;
        line-height: 48px;
        text-align: center;
      }
      .item-middle {
        width: 100%;
        height: 360px;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 5px 15px 0px rgba(158, 25, 22, 0.1);
        border-radius: 20px;
        border: 1px solid #ffffff;
        margin-top: 123px;
        padding: 50px 60px;
        font-family: MicrosoftYaHei;
        box-sizing: border-box;
        h2 {
          font-size: 32px;
          color: #3e3e3e;
          font-weight: 500;
          margin-bottom: 55px;
          font-weight: 600;
        }
        .flex-box {
          width: 100%;
          max-width: 600px;
          flex-wrap: wrap;
          .des-item {
            margin-bottom: 40px;
            margin-right: 100px;
            z-index: 2;
            img {
              width: 30px;
              height: 30px;
            }
            .des-item-right {
              margin-left: 20px;

              p {
                height: 26px;
                font-size: 20px;
                color: #3e3e3e;
                line-height: 26px;
              }
              span {
                display: block;
                height: 21px;
                margin-top: 10px;
                font-size: 16px;
                color: #585f65;
                line-height: 21px;
              }
            }
          }
        }
      }
      .kf {
        position: absolute;
        width: 817px;
        height: 425px;
        right: 20px;
        top: 105px;
      }
    }
  }

.enjoy-shopping {
  background-image: url("https://ztc-obs.zgztc.cn/2025/12/25/02e45438-ece0-4c0a-b07f-fb6fe46563ed.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  min-height: 280px;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  right: 0;

  .enjoy-shopping-item {
    width: 100%;
    max-width: 1170px;
    margin: 50px auto;
    padding: 0 20px;
    box-sizing: border-box;

    .title {
      height: 64px;
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 48px;
      color: #ffffff;
      line-height: 64px;
    }
    .des {
      height: 29px;
      font-family: Helvetica, Helvetica;
      font-size: 20px;
      color: #ffffff;
      line-height: 29px;
      margin-top: 15px;
      span {
        font-weight: bold;
        font-weight: 24px;
      }
    }

    .item-button {
      margin-top: 35px;
      width: 150px;
      height: 48px;
      background: rgba(255, 255, 255, 0);
      border-radius: 25px;
      border: 1px solid #ffffff;
      line-height: 48px;
      text-align: center;
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
      .arrow-icon {
        width: 16px;
        height: 11px;
        display: block;
        margin-left: 10px;
        transition: all 0.3s ease;
      }
    }

    .item-button:hover {
      background: #ffffff;
      color: red;
      border-color: red;
      .arrow-icon {
        content: url("../../assets/imgs/rightred.png");
      }
    }
  }
}

  .foot {
    width: 100%;
    max-width: 1920px;
    height: 150px;
    background: #000000;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .foot-item {
      width: 100%;
      max-width: 1170px;
      margin: 43px auto;
      padding: 0 20px;
      box-sizing: border-box;
      font-family: MicrosoftYaHei;
      .foot-item-left {
        img {
          width: 150px;
          height: 28px;
        }
        .des {
          margin-top: 15px;
          height: 21px;

          font-size: 16px;
          color: #ffffff;
          line-height: 21px;
          flex-wrap: wrap;
        }

        .beian-link {
          text-decoration: none;
          color: inherit;
          transition: text-decoration-color 0.2s ease;
        }

        .beian-link:hover {
          text-decoration: underline;
          text-decoration-color: #ffffff;
        }

        .police{
          margin-left: 30px;
          img{
            width:20px;
            height: 20px;
            margin-right: 5px;
          }
        }
      }
      .foot-item-right {
        p {
          height: 21px;
          font-size: 16px;
          color: #ffffff;
          line-height: 21px;
          margin-bottom: 10px;
        }
        span {
          display: block;
          height: 31px;
          font-family: Helvetica, Helvetica;
          font-weight: bold;
          font-size: 26px;
          color: #ffffff;
          line-height: 31px;
        }
      }
    }
  }
}

// 响应式适配
@media (max-width: 1170px) {
  .container {
    .website-header-bg {
      height: auto;
      min-height: 870px;
      
      .website-header-middle {
        margin-top: 200px;
        padding-bottom: 100px;
      }
    }

    .download {
      height: auto;
      min-height: 375px;
      padding: 40px 20px;
      flex-direction: column;
      text-align: center;
      
      .download-left {
        margin-top: 0;
        margin-bottom: 40px;
        
        p {
          line-height: 1.3;
        }
        
        span {
          margin-top: 20px;
        }
      }
      
      .download-right {
        justify-content: center;
        width: 100%;
        
        .right-inner {
          margin: 10px;
        }
      }
    }

    .dataAccumulation {
      height: auto;
      min-height: 480px;
      
      .dataAccumulation-item {
        padding: 60px 20px;
        
        .item-middle {
          margin-top: 40px;
          gap: 40px;
          
          .flex-item {
            margin-right: 0;
            width: 180px;
          }
        }
      }
    }

    .after-sales {
      height: auto;
      min-height: 710px;
      
      .after-sales-item {
        margin: 60px auto;
        
        .item-middle {
          height: auto;
          min-height: 360px;
          margin-top: 80px;
          padding: 30px;
          
          .flex-box {
            .des-item {
              width: 45%;
              margin-right: 20px;
              margin-bottom: 30px;
            }
          }
        }
        
        .kf {
          display: none;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .container {
    .website-header-bg {
      .website-header {
        .website-header-container {
          .container-right {
            width: auto;
            .orderBtn {
              width: 80px;
              font-size: 14px;
            }
          }
        }
      }
      
      .website-header-middle {
        .slogin {
          font-size: 32px;
        }
        
        .slogin-des {
          font-size: 16px;
        }
      }
    }

    .download {
      .download-left {
        p {
          font-size: 28px;
          line-height: 1.2;
        }
        
        span {
          font-size: 16px;
        }
      }
      
      .download-right {
        .right-inner {
          width: 130px;
          font-size: 16px;
          
          img {
            width: 130px;
            height: 130px;
          }
        }
      }
    }

    .dataAccumulation {
      .dataAccumulation-item {
        .item-header {
          p {
            font-size: 36px;
          }
          
          span {
            font-size: 16px;
          }
        }
        
        .item-middle {
          gap: 30px;
          
          .flex-item {
            width: 150px;
            
            .big-text {
              p {
                font-size: 36px;
              }
              
              span {
                font-size: 18px;
              }
            }
          }
        }
      }
    }

    .slogan {
      .slogan-item {
        p {
          font-size: 36px;
          line-height: 1.2;
          height: auto;
        }
        
        .item-des {
          font-size: 18px;
          height: auto;
        }
      }
    }

    .after-sales {
      .after-sales-item {
        .title {
          font-size: 36px;
        }
        
        .item-middle {
          padding: 20px;
          
          h2 {
            font-size: 24px;
            margin-bottom: 30px;
          }
          
          .flex-box {
            .des-item {
              width: 100%;
              margin-right: 0;
              margin-bottom: 20px;
              
              .des-item-right {
                p {
                  font-size: 18px;
                }
                
                span {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }

    .enjoy-shopping {
      .enjoy-shopping-item {
        .title {
          font-size: 36px;
          line-height: 1.2;
        }
        
        .des {
          font-size: 16px;
        }
      }
    }

    .foot {
      height: auto;
      min-height: 150px;
      
      .foot-item {
        flex-direction: column;
        text-align: center;
        margin: 20px auto;
        
        .foot-item-left {
          .des {
            justify-content: center;
            text-align: center;
            
            .police {
              margin-left: 0;
              justify-content: center;
              margin-top: 10px;
            }
          }
        }
        
        .foot-item-right {
          margin-top: 20px;
          
          span {
            font-size: 22px;
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .container {
    .website-header-bg {
      .website-header-middle {
        margin-top: 150px;
        
        .slogin {
          font-size: 24px;
          margin: 20px auto 10px;
        }
        
        .slogin-des {
          font-size: 14px;
        }
      }
    }

    .download {
      .download-left {
        p {
          font-size: 24px;
        }
        
        span {
          font-size: 14px;
        }
      }
    }

    .dataAccumulation {
      .dataAccumulation-item {
        .item-header {
          p {
            font-size: 28px;
          }
          
          span {
            font-size: 14px;
          }
        }
        
        .item-middle {
          flex-direction: column;
          gap: 20px;
          
          .flex-item {
            width: 100%;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
}
</style>